import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Admin from "../pages/admin/page";
import NutricionistaPalmaPage from "../pages/seo/NutricionistaPalmaPage";
import NutricionDeportivaPage from "../pages/seo/NutricionDeportivaPage";
import AdelgazarPage from "../pages/seo/AdelgazarPage";
import NutricionistaPalmaPageShort from "../pages/seo/NutricionistaPalmaPageShort";
import DietistaPalmaPage from "../pages/seo/DietistaPalmaPage";
import NutricionistaClinicoPalmaPage from "../pages/seo/NutricionistaClinicoPalmaPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/nutricionista-palma-de-mallorca",
    element: <NutricionistaPalmaPage />,
  },
  {
    path: "/nutricionista-palma",
    element: <NutricionistaPalmaPageShort />,
  },
  {
    path: "/dietista-palma-de-mallorca",
    element: <DietistaPalmaPage />,
  },
  {
    path: "/nutricionista-clinico-palma-de-mallorca",
    element: <NutricionistaClinicoPalmaPage />,
  },
  {
    path: "/nutricion-deportiva-palma-de-mallorca",
    element: <NutricionDeportivaPage />,
  },
  {
    path: "/adelgazar-palma-de-mallorca",
    element: <AdelgazarPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
